"use strict";
exports.__esModule = true;
exports.useCluster = void 0;
var React = require("react");
exports.useCluster = function (clusterConfig, clusterer, rawPins) {
    var GRID_SIZE = 80;
    var _a = React.useState(), map = _a[0], setMap = _a[1];
    var _b = React.useState([]), oldPins = _b[0], setOldPins = _b[1];
    var _c = React.useState([]), pins = _c[0], setPins = _c[1];
    var _d = React.useState(), viewport = _d[0], setViewport = _d[1];
    var _e = React.useState(GRID_SIZE), gridSize = _e[0], setGridSize = _e[1];
    var _f = React.useState(false), showAll = _f[0], setShowAll = _f[1];
    var _g = React.useState(0), update = _g[0], setUpdate = _g[1];
    var cluster = function (map, oldPins, setPins, gridSize, showAll) {
        if (gridSize === void 0) { gridSize = 120; }
        if (showAll === void 0) { showAll = false; }
        if (!map)
            return;
        var gridInfo = {};
        var getAverageLocation = function (locations) {
            var xSum = 0;
            var ySum = 0;
            locations.map(function (it) {
                xSum += it.lat;
                ySum += it.lng;
            });
            return { lat: xSum / locations.length, lng: ySum / locations.length };
        };
        var getIndex = function (start, end, length, target) {
            var outerStart = start - (end - start);
            var outerEnd = end + (end - start);
            var startingI = Math.floor(outerStart / length) * length;
            var endingI = Math.ceil(outerEnd / length) * length;
            for (var i = startingI, j = 0; i < endingI; i += length, j += 1) {
                if (target > i)
                    continue;
                return j;
            }
            return -1;
        };
        var getCoord = function (map, lagLng, gridSize, nePoint, swPoint) {
            var mapContainerLength = map.getDiv().clientWidth;
            var pinPoint = map.getProjection().fromLatLngToPoint(new google.maps.LatLng(lagLng.lat, lagLng.lng));
            var screenX = nePoint.x - swPoint.x;
            var screenY = swPoint.y - nePoint.y;
            if (pinPoint.x < (swPoint.x - screenX) ||
                pinPoint.x > (nePoint.x + screenX) ||
                pinPoint.y > (swPoint.y + screenY) ||
                pinPoint.y < (nePoint.y - screenY)) {
                if (showAll) {
                    return { lat: -1, lng: -1 };
                }
            }
            var mapLength = Math.abs(nePoint.x - swPoint.x);
            var scale = mapContainerLength / mapLength;
            var gridLength = gridSize / scale;
            var lat = getIndex(swPoint.x, nePoint.x, gridLength, pinPoint.x);
            var lng = getIndex(nePoint.y, swPoint.y, gridLength, pinPoint.y);
            return {
                lat: lat,
                lng: lng
            };
        };
        var nePoint = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
        var swPoint = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
        var coordToKey = function (coord) { return coord.lat + "-" + coord.lng; };
        // Group pins into grid by using LatLng as key
        oldPins.filter(function (it) { return !it.noCluster; }).map(function (it) {
            var coord = getCoord(map, { lat: it.lat, lng: it.lng }, gridSize, nePoint, swPoint);
            if (coord.lat === -1 || coord.lng === -1)
                return;
            var key = coordToKey(coord);
            if (!gridInfo[key]) {
                gridInfo[key] = { position: null, items: [] };
            }
            gridInfo[key].items.push(it);
        });
        // Calculate average position of grouped pins on each grid cell
        Object.entries(gridInfo).map(function (_a) {
            var gridKey = _a[0], gridInfoValue = _a[1];
            var nodeLatLngs = gridInfo[gridKey].items
                .map(function (it) { return ({ lat: Number(it.lat), lng: Number(it.lng) }); });
            gridInfo[gridKey].position = getAverageLocation(nodeLatLngs);
        });
        // Render clustered Pin (title/count) using custom logic
        var clusteredPins = Object.entries(gridInfo)
            .map(function (_a) {
            var gridKey = _a[0], gridInfoValue = _a[1];
            return clusterer(gridInfoValue, viewport);
        })
            .concat(oldPins.filter(function (it) { return it.noCluster; }));
        setPins(clusteredPins);
    };
    var onViewportChanged = function (viewport) {
        setViewport(viewport);
    };
    React.useEffect(function () {
        setOldPins(rawPins);
    }, [rawPins]);
    React.useEffect(function () {
        if (!clusterConfig)
            return;
        setGridSize(clusterConfig.gridSize);
        setShowAll(clusterConfig.showAll);
        setUpdate(update + 1);
    }, [clusterConfig]);
    React.useEffect(function () {
        if (!viewport)
            return;
        setUpdate(update + 1);
    }, [viewport]);
    React.useEffect(function () {
        if (!viewport || !clusterConfig)
            return;
        cluster(map, oldPins, setPins, gridSize, showAll);
    }, [oldPins, update]);
    return { pins: pins, onViewportChanged: onViewportChanged, setMap: setMap };
};
